export const QUEUE_FIXED_WIDTH = 288;
export const QUEUE_FULL_WIDTH = '100%';
